import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-bottom-modal',
  templateUrl: './bottom-modal.component.html',
  styleUrls: ['./bottom-modal.component.scss'],
})
export class BottomModalComponent implements OnInit {
  @Input() menuItem: any;
  @Input() currencyCode: string;
  veg = '../../../../assets/icon/veg.svg';
  templateData = {
    header: 'Previous Customization',
    subheader: 'tall, low fat milk, whip cream',
    btn_choose: 'I\'ll CHOOSE',
    btn_repeat: 'REPEAT'
  };
  constructor(private modalController: ModalController) { }

  ngOnInit() { }
  customizeMenu() {
    this.modalController.dismiss({
      methodType: 'customize',
      menuItem: this.menuItem
    });
  }

  repeatCustomization() {
    this.modalController.dismiss({
      methodType: 'repeat',
      menuItem: this.menuItem
    });
  }
}
